import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledLink = styled.a`
  display: inline-flex;
`;

export const StyledWrapper = styled.div`
  display: inline-flex;

  svg {
    max-width: ${rem('127px')};
    height: auto;
  }
`;
